import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { routes } from "../../routes/routes";
import AuthClient from "../../api/AuthClient";
import { CitiesInfoContext } from "../../AllCitiesContext";
import { getCurrentCity } from "../../utils/currentCity";

export default function PromoterBannerCityLink() {
    const [cityName, setCityName] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const { selectedCity } = useContext(CitiesInfoContext);

  useEffect(() => {
    const auth = new AuthClient().getAuthenticationResponse();
    const currentCity = getCurrentCity(auth);
    if (currentCity) {
      setCityName(currentCity.cityName);
    }
  }, [selectedCity]);

    useEffect(() => {
        const syncDropdownState = () => {
            setIsDropdownOpen(Boolean(document.querySelector('[class*="dropdownContent"]')));
        };

        syncDropdownState();

        const observer = new MutationObserver(() => {
            syncDropdownState();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <Link
            className={`promoterBannerCityLink${isDropdownOpen ? " promoterBannerCityLink--hidden" : ""}`}
            to={routes.CitySelector}
            title="Change city"
        >
            {cityName || "City"}
        </Link>
    );
}
